class UsCities {
   cities() {
      return [
       {
         "City": "New York",
         "Coordinates": "40.7127837,-74.0059413"
       },
       {
         "City": "Los Angeles",
         "Coordinates": "34.0522342,-118.2436849"
       },
       {
         "City": "Chicago",
         "Coordinates": "41.8781136,-87.6297982"
       },
       {
         "City": "Houston",
         "Coordinates": "29.7604267,-95.3698028"
       },
       {
         "City": "Philadelphia",
         "Coordinates": "39.9525839,-75.1652215"
       },
       {
         "City": "Phoenix",
         "Coordinates": "33.4483771,-112.0740373"
       },
       {
         "City": "San Antonio",
         "Coordinates": "29.4241219,-98.4936282"
       },
       {
         "City": "San Diego",
         "Coordinates": "32.715738,-117.1610838"
       },
       {
         "City": "Dallas",
         "Coordinates": "32.7766642,-96.7969879"
       },
       {
         "City": "San Jose",
         "Coordinates": "37.3382082,-121.8863286"
       },
       {
         "City": "Austin",
         "Coordinates": "30.267153,-97.7430608"
       },
       {
         "City": "Indianapolis",
         "Coordinates": "39.768403,-86.158068"
       },
       {
         "City": "Jacksonville",
         "Coordinates": "30.3321838,-81.655651"
       },
       {
         "City": "San Francisco",
         "Coordinates": "37.7749295,-122.4194155"
       },
       {
         "City": "Columbus",
         "Coordinates": "39.9611755,-82.9987942"
       },
       {
         "City": "Charlotte",
         "Coordinates": "35.2270869,-80.8431267"
       },
       {
         "City": "Fort Worth",
         "Coordinates": "32.7554883,-97.3307658"
       },
       {
         "City": "Detroit",
         "Coordinates": "42.331427,-83.0457538"
       },
       {
         "City": "El Paso",
         "Coordinates": "31.7775757,-106.4424559"
       },
       {
         "City": "Memphis",
         "Coordinates": "35.1495343,-90.0489801"
       },
       {
         "City": "Seattle",
         "Coordinates": "47.6062095,-122.3320708"
       },
       {
         "City": "Denver",
         "Coordinates": "39.7392358,-104.990251"
       },
       {
         "City": "Washington",
         "Coordinates": "38.9071923,-77.0368707"
       },
       {
         "City": "Boston",
         "Coordinates": "42.3600825,-71.0588801"
       },
       {
         "City": "Nashville",
         "Coordinates": "36.1626638,-86.7816016"
       },
       {
         "City": "Baltimore",
         "Coordinates": "39.2903848,-76.6121893"
       },
       {
         "City": "Oklahoma City",
         "Coordinates": "35.4675602,-97.5164276"
       },
       {
         "City": "Louisville",
         "Coordinates": "38.2526647,-85.7584557"
       },
       {
         "City": "Portland",
         "Coordinates": "45.5230622,-122.6764816"
       },
       {
         "City": "Las Vegas",
         "Coordinates": "36.1699412,-115.1398296"
       },
       {
         "City": "Milwaukee",
         "Coordinates": "43.0389025,-87.9064736"
       },
       {
         "City": "Albuquerque",
         "Coordinates": "35.0853336,-106.6055534"
       },
       {
         "City": "Tucson",
         "Coordinates": "32.2217429,-110.926479"
       },
       {
         "City": "Fresno",
         "Coordinates": "36.7468422,-119.7725868"
       },
       {
         "City": "Sacramento",
         "Coordinates": "38.5815719,-121.4943996"
       },
       {
         "City": "Long Beach",
         "Coordinates": "33.7700504,-118.1937395"
       },
       {
         "City": "Kansas City",
         "Coordinates": "39.0997265,-94.5785667"
       },
       {
         "City": "Mesa",
         "Coordinates": "33.4151843,-111.8314724"
       },
       {
         "City": "Virginia Beach",
         "Coordinates": "36.8529263,-75.977985"
       },
       {
         "City": "Atlanta",
         "Coordinates": "33.7489954,-84.3879824"
       },
       {
         "City": "Colorado Springs",
         "Coordinates": "38.8338816,-104.8213634"
       },
       {
         "City": "Omaha",
         "Coordinates": "41.2523634,-95.9979883"
       },
       {
         "City": "Raleigh",
         "Coordinates": "35.7795897,-78.6381787"
       },
       {
         "City": "Miami",
         "Coordinates": "25.7616798,-80.1917902"
       },
       {
         "City": "Oakland",
         "Coordinates": "37.8043637,-122.2711137"
       },
       {
         "City": "Minneapolis",
         "Coordinates": "44.977753,-93.2650108"
       },
       {
         "City": "Tulsa",
         "Coordinates": "36.1539816,-95.992775"
       },
       {
         "City": "Cleveland",
         "Coordinates": "41.49932,-81.6943605"
       },
       {
         "City": "Wichita",
         "Coordinates": "37.688889,-97.336111"
       },
       {
         "City": "Arlington",
         "Coordinates": "32.735687,-97.1080656"
       },
       {
         "City": "New Orleans",
         "Coordinates": "29.9510658,-90.0715323"
       },
       {
         "City": "Bakersfield",
         "Coordinates": "35.3732921,-119.0187125"
       },
       {
         "City": "Tampa",
         "Coordinates": "27.950575,-82.4571776"
       },
       {
         "City": "Honolulu",
         "Coordinates": "21.3069444,-157.8583333"
       },
       {
         "City": "Aurora",
         "Coordinates": "39.7294319,-104.8319195"
       },
       {
         "City": "Anaheim",
         "Coordinates": "33.8352932,-117.9145036"
       },
       {
         "City": "Santa Ana",
         "Coordinates": "33.7455731,-117.8678338"
       },
       {
         "City": "St. Louis",
         "Coordinates": "38.6270025,-90.1994042"
       },
       {
         "City": "Riverside",
         "Coordinates": "33.9533487,-117.3961564"
       },
       {
         "City": "Corpus Christi",
         "Coordinates": "27.8005828,-97.396381"
       },
       {
         "City": "Lexington-Fayette",
         "Coordinates": "38.0405837,-84.5037164"
       },
       {
         "City": "Pittsburgh",
         "Coordinates": "40.4406248,-79.9958864"
       },
       {
         "City": "Anchorage",
         "Coordinates": "61.2180556,-149.9002778"
       },
       {
         "City": "Stockton",
         "Coordinates": "37.9577016,-121.2907796"
       },
       {
         "City": "Cincinnati",
         "Coordinates": "39.1031182,-84.5120196"
       },
       {
         "City": "St. Paul",
         "Coordinates": "44.9537029,-93.0899578"
       },
       {
         "City": "Toledo",
         "Coordinates": "41.6639383,-83.555212"
       },
       {
         "City": "Greensboro",
         "Coordinates": "36.0726354,-79.7919754"
       },
       {
         "City": "Newark",
         "Coordinates": "40.735657,-74.1723667"
       },
       {
         "City": "Plano",
         "Coordinates": "33.0198431,-96.6988856"
       },
       {
         "City": "Henderson",
         "Coordinates": "36.0395247,-114.9817213"
       },
       {
         "City": "Lincoln",
         "Coordinates": "40.8257625,-96.6851982"
       },
       {
         "City": "Buffalo",
         "Coordinates": "42.8864468,-78.8783689"
       },
       {
         "City": "Jersey City",
         "Coordinates": "40.7281575,-74.0776417"
       },
       {
         "City": "Chula Vista",
         "Coordinates": "32.6400541,-117.0841955"
       },
       {
         "City": "Fort Wayne",
         "Coordinates": "41.079273,-85.1393513"
       },
       {
         "City": "Orlando",
         "Coordinates": "28.5383355,-81.3792365"
       },
       {
         "City": "St. Petersburg",
         "Coordinates": "27.773056,-82.64"
       },
       {
         "City": "Chandler",
         "Coordinates": "33.3061605,-111.8412502"
       },
       {
         "City": "Laredo",
         "Coordinates": "27.5305671,-99.4803241"
       },
       {
         "City": "Norfolk",
         "Coordinates": "36.8507689,-76.2858726"
       },
       {
         "City": "Durham",
         "Coordinates": "35.9940329,-78.898619"
       },
       {
         "City": "Madison",
         "Coordinates": "43.0730517,-89.4012302"
       },
       {
         "City": "Lubbock",
         "Coordinates": "33.5778631,-101.8551665"
       },
       {
         "City": "Irvine",
         "Coordinates": "33.6839473,-117.7946942"
       },
       {
         "City": "Winston-Salem",
         "Coordinates": "36.0998596,-80.244216"
       },
       {
         "City": "Glendale",
         "Coordinates": "33.5386523,-112.1859866"
       },
       {
         "City": "Garland",
         "Coordinates": "32.912624,-96.6388833"
       },
       {
         "City": "Hialeah",
         "Coordinates": "25.8575963,-80.2781057"
       },
       {
         "City": "Reno",
         "Coordinates": "39.5296329,-119.8138027"
       },
       {
         "City": "Chesapeake",
         "Coordinates": "36.7682088,-76.2874927"
       },
       {
         "City": "Gilbert",
         "Coordinates": "33.3528264,-111.789027"
       },
       {
         "City": "Baton Rouge",
         "Coordinates": "30.4582829,-91.1403196"
       },
       {
         "City": "Irving",
         "Coordinates": "32.8140177,-96.9488945"
       },
       {
         "City": "Scottsdale",
         "Coordinates": "33.4941704,-111.9260519"
       },
       {
         "City": "North Las Vegas",
         "Coordinates": "36.1988592,-115.1175013"
       },
       {
         "City": "Fremont",
         "Coordinates": "37.5482697,-121.9885719"
       },
       {
         "City": "Boise City",
         "Coordinates": "43.6187102,-116.2146068"
       },
       {
         "City": "Richmond",
         "Coordinates": "37.5407246,-77.4360481"
       },
       {
         "City": "San Bernardino",
         "Coordinates": "34.1083449,-117.2897652"
       },
       {
         "City": "Birmingham",
         "Coordinates": "33.5206608,-86.80249"
       },
       {
         "City": "Spokane",
         "Coordinates": "47.6587802,-117.4260466"
       },
       {
         "City": "Rochester",
         "Coordinates": "43.16103,-77.6109219"
       },
       {
         "City": "Des Moines",
         "Coordinates": "41.6005448,-93.6091064"
       },
       {
         "City": "Modesto",
         "Coordinates": "37.6390972,-120.9968782"
       },
       {
         "City": "Fayetteville",
         "Coordinates": "35.0526641,-78.8783585"
       },
       {
         "City": "Tacoma",
         "Coordinates": "47.2528768,-122.4442906"
       },
       {
         "City": "Oxnard",
         "Coordinates": "34.1975048,-119.1770516"
       },
       {
         "City": "Fontana",
         "Coordinates": "34.0922335,-117.435048"
       },
       {
         "City": "Columbus",
         "Coordinates": "32.4609764,-84.9877094"
       },
       {
         "City": "Montgomery",
         "Coordinates": "32.3668052,-86.2999689"
       },
       {
         "City": "Moreno Valley",
         "Coordinates": "33.9424658,-117.2296717"
       },
       {
         "City": "Shreveport",
         "Coordinates": "32.5251516,-93.7501789"
       },
       {
         "City": "Aurora",
         "Coordinates": "41.7605849,-88.3200715"
       },
       {
         "City": "Yonkers",
         "Coordinates": "40.9312099,-73.8987469"
       },
       {
         "City": "Akron",
         "Coordinates": "41.0814447,-81.5190053"
       },
       {
         "City": "Huntington Beach",
         "Coordinates": "33.660297,-117.9992265"
       },
       {
         "City": "Little Rock",
         "Coordinates": "34.7464809,-92.2895948"
       },
       {
         "City": "Augusta-Richmond County",
         "Coordinates": "33.4734978,-82.0105148"
       },
       {
         "City": "Amarillo",
         "Coordinates": "35.2219971,-101.8312969"
       },
       {
         "City": "Glendale",
         "Coordinates": "34.1425078,-118.255075"
       },
       {
         "City": "Mobile",
         "Coordinates": "30.6953657,-88.0398912"
       },
       {
         "City": "Grand Rapids",
         "Coordinates": "42.9633599,-85.6680863"
       },
       {
         "City": "Salt Lake City",
         "Coordinates": "40.7607793,-111.8910474"
       },
       {
         "City": "Tallahassee",
         "Coordinates": "30.4382559,-84.2807329"
       },
       {
         "City": "Huntsville",
         "Coordinates": "34.7303688,-86.5861037"
       },
       {
         "City": "Grand Prairie",
         "Coordinates": "32.7459645,-96.9977846"
       },
       {
         "City": "Knoxville",
         "Coordinates": "35.9606384,-83.9207392"
       },
       {
         "City": "Worcester",
         "Coordinates": "42.2625932,-71.8022934"
       },
       {
         "City": "Newport News",
         "Coordinates": "37.0870821,-76.4730122"
       },
       {
         "City": "Brownsville",
         "Coordinates": "25.9017472,-97.4974838"
       },
       {
         "City": "Overland Park",
         "Coordinates": "38.9822282,-94.6707917"
       },
       {
         "City": "Santa Clarita",
         "Coordinates": "34.3916641,-118.542586"
       },
       {
         "City": "Providence",
         "Coordinates": "41.8239891,-71.4128343"
       },
       {
         "City": "Garden Grove",
         "Coordinates": "33.7739053,-117.9414477"
       },
       {
         "City": "Chattanooga",
         "Coordinates": "35.0456297,-85.3096801"
       },
       {
         "City": "Oceanside",
         "Coordinates": "33.1958696,-117.3794834"
       },
       {
         "City": "Jackson",
         "Coordinates": "32.2987573,-90.1848103"
       },
       {
         "City": "Fort Lauderdale",
         "Coordinates": "26.1224386,-80.1373174"
       },
       {
         "City": "Santa Rosa",
         "Coordinates": "38.440429,-122.7140548"
       },
       {
         "City": "Rancho Cucamonga",
         "Coordinates": "34.1063989,-117.5931084"
       },
       {
         "City": "Port St. Lucie",
         "Coordinates": "27.2730492,-80.3582261"
       },
       {
         "City": "Tempe",
         "Coordinates": "33.4255104,-111.9400054"
       },
       {
         "City": "Ontario",
         "Coordinates": "34.0633443,-117.6508876"
       },
       {
         "City": "Vancouver",
         "Coordinates": "45.6387281,-122.6614861"
       },
       {
         "City": "Cape Coral",
         "Coordinates": "26.5628537,-81.9495331"
       },
       {
         "City": "Sioux Falls",
         "Coordinates": "43.5445959,-96.7311034"
       },
       {
         "City": "Springfield",
         "Coordinates": "37.2089572,-93.2922989"
       },
       {
         "City": "Peoria",
         "Coordinates": "33.5805955,-112.2373779"
       },
       {
         "City": "Pembroke Pines",
         "Coordinates": "26.007765,-80.2962555"
       },
       {
         "City": "Elk Grove",
         "Coordinates": "38.4087993,-121.3716178"
       },
       {
         "City": "Salem",
         "Coordinates": "44.9428975,-123.0350963"
       },
       {
         "City": "Lancaster",
         "Coordinates": "34.6867846,-118.1541632"
       },
       {
         "City": "Corona",
         "Coordinates": "33.8752935,-117.5664384"
       },
       {
         "City": "Eugene",
         "Coordinates": "44.0520691,-123.0867536"
       },
       {
         "City": "Palmdale",
         "Coordinates": "34.5794343,-118.1164613"
       },
       {
         "City": "Salinas",
         "Coordinates": "36.6777372,-121.6555013"
       },
       {
         "City": "Springfield",
         "Coordinates": "42.1014831,-72.589811"
       },
       {
         "City": "Pasadena",
         "Coordinates": "29.6910625,-95.2091006"
       },
       {
         "City": "Fort Collins",
         "Coordinates": "40.5852602,-105.084423"
       },
       {
         "City": "Hayward",
         "Coordinates": "37.6688205,-122.0807964"
       },
       {
         "City": "Pomona",
         "Coordinates": "34.055103,-117.7499909"
       },
       {
         "City": "Cary",
         "Coordinates": "35.79154,-78.7811169"
       },
       {
         "City": "Rockford",
         "Coordinates": "42.2711311,-89.0939952"
       },
       {
         "City": "Alexandria",
         "Coordinates": "38.8048355,-77.0469214"
       },
       {
         "City": "Escondido",
         "Coordinates": "33.1192068,-117.086421"
       },
       {
         "City": "McKinney",
         "Coordinates": "33.1972465,-96.6397822"
       },
       {
         "City": "Kansas City",
         "Coordinates": "39.114053,-94.6274636"
       },
       {
         "City": "Joliet",
         "Coordinates": "41.525031,-88.0817251"
       },
       {
         "City": "Sunnyvale",
         "Coordinates": "37.36883,-122.0363496"
       },
       {
         "City": "Torrance",
         "Coordinates": "33.8358492,-118.3406288"
       },
       {
         "City": "Bridgeport",
         "Coordinates": "41.1865478,-73.1951767"
       },
       {
         "City": "Lakewood",
         "Coordinates": "39.7047095,-105.0813734"
       },
       {
         "City": "Hollywood",
         "Coordinates": "26.0112014,-80.1494901"
       },
       {
         "City": "Paterson",
         "Coordinates": "40.9167654,-74.171811"
       },
       {
         "City": "Naperville",
         "Coordinates": "41.7508391,-88.1535352"
       },
       {
         "City": "Syracuse",
         "Coordinates": "43.0481221,-76.1474244"
       },
       {
         "City": "Mesquite",
         "Coordinates": "32.7667955,-96.5991593"
       },
       {
         "City": "Dayton",
         "Coordinates": "39.7589478,-84.1916069"
       },
       {
         "City": "Savannah",
         "Coordinates": "32.0835407,-81.0998342"
       },
       {
         "City": "Clarksville",
         "Coordinates": "36.5297706,-87.3594528"
       },
       {
         "City": "Orange",
         "Coordinates": "33.7877944,-117.8531119"
       },
       {
         "City": "Pasadena",
         "Coordinates": "34.1477849,-118.1445155"
       },
       {
         "City": "Fullerton",
         "Coordinates": "33.8703596,-117.9242966"
       },
       {
         "City": "Killeen",
         "Coordinates": "31.1171194,-97.7277959"
       },
       {
         "City": "Frisco",
         "Coordinates": "33.1506744,-96.8236116"
       },
       {
         "City": "Hampton",
         "Coordinates": "37.0298687,-76.3452218"
       },
       {
         "City": "McAllen",
         "Coordinates": "26.2034071,-98.2300124"
       },
       {
         "City": "Warren",
         "Coordinates": "42.5144566,-83.0146526"
       },
       {
         "City": "Bellevue",
         "Coordinates": "47.610377,-122.2006786"
       },
       {
         "City": "West Valley City",
         "Coordinates": "40.6916132,-112.0010501"
       },
       {
         "City": "Columbia",
         "Coordinates": "34.0007104,-81.0348144"
       },
       {
         "City": "Olathe",
         "Coordinates": "38.8813958,-94.8191285"
       },
       {
         "City": "Sterling Heights",
         "Coordinates": "42.5803122,-83.0302033"
       },
       {
         "City": "New Haven",
         "Coordinates": "41.308274,-72.9278835"
       },
       {
         "City": "Miramar",
         "Coordinates": "25.9860762,-80.3035602"
       },
       {
         "City": "Waco",
         "Coordinates": "31.549333,-97.1466695"
       },
       {
         "City": "Thousand Oaks",
         "Coordinates": "34.1705609,-118.8375937"
       },
       {
         "City": "Cedar Rapids",
         "Coordinates": "41.9778795,-91.6656232"
       },
       {
         "City": "Charleston",
         "Coordinates": "32.7764749,-79.9310512"
       },
       {
         "City": "Visalia",
         "Coordinates": "36.3302284,-119.2920585"
       },
       {
         "City": "Topeka",
         "Coordinates": "39.0558235,-95.6890185"
       },
       {
         "City": "Elizabeth",
         "Coordinates": "40.6639916,-74.2107006"
       },
       {
         "City": "Gainesville",
         "Coordinates": "29.6516344,-82.3248262"
       },
       {
         "City": "Thornton",
         "Coordinates": "39.8680412,-104.9719243"
       },
       {
         "City": "Roseville",
         "Coordinates": "38.7521235,-121.2880059"
       },
       {
         "City": "Carrollton",
         "Coordinates": "32.9756415,-96.8899636"
       },
       {
         "City": "Coral Springs",
         "Coordinates": "26.271192,-80.2706044"
       },
       {
         "City": "Stamford",
         "Coordinates": "41.0534302,-73.5387341"
       },
       {
         "City": "Simi Valley",
         "Coordinates": "34.2694474,-118.781482"
       },
       {
         "City": "Concord",
         "Coordinates": "37.9779776,-122.0310733"
       },
       {
         "City": "Hartford",
         "Coordinates": "41.7637111,-72.6850932"
       },
       {
         "City": "Kent",
         "Coordinates": "47.3809335,-122.2348431"
       },
       {
         "City": "Lafayette",
         "Coordinates": "30.2240897,-92.0198427"
       },
       {
         "City": "Midland",
         "Coordinates": "31.9973456,-102.0779146"
       },
       {
         "City": "Surprise",
         "Coordinates": "33.6292337,-112.3679279"
       },
       {
         "City": "Denton",
         "Coordinates": "33.2148412,-97.1330683"
       },
       {
         "City": "Victorville",
         "Coordinates": "34.5362184,-117.2927641"
       },
       {
         "City": "Evansville",
         "Coordinates": "37.9715592,-87.5710898"
       },
       {
         "City": "Santa Clara",
         "Coordinates": "37.3541079,-121.9552356"
       },
       {
         "City": "Abilene",
         "Coordinates": "32.4487364,-99.7331439"
       },
       {
         "City": "Athens-Clarke County",
         "Coordinates": "33.9519347,-83.357567"
       },
       {
         "City": "Vallejo",
         "Coordinates": "38.1040864,-122.2566367"
       },
       {
         "City": "Allentown",
         "Coordinates": "40.6084305,-75.4901833"
       },
       {
         "City": "Norman",
         "Coordinates": "35.2225668,-97.4394777"
       },
       {
         "City": "Beaumont",
         "Coordinates": "30.080174,-94.1265562"
       },
       {
         "City": "Independence",
         "Coordinates": "39.0911161,-94.4155068"
       },
       {
         "City": "Murfreesboro",
         "Coordinates": "35.8456213,-86.39027"
       },
       {
         "City": "Ann Arbor",
         "Coordinates": "42.2808256,-83.7430378"
       },
       {
         "City": "Springfield",
         "Coordinates": "39.7817213,-89.6501481"
       },
       {
         "City": "Berkeley",
         "Coordinates": "37.8715926,-122.272747"
       },
       {
         "City": "Peoria",
         "Coordinates": "40.6936488,-89.5889864"
       },
       {
         "City": "Provo",
         "Coordinates": "40.2338438,-111.6585337"
       },
       {
         "City": "El Monte",
         "Coordinates": "34.0686206,-118.0275667"
       },
       {
         "City": "Columbia",
         "Coordinates": "38.9517053,-92.3340724"
       },
       {
         "City": "Lansing",
         "Coordinates": "42.732535,-84.5555347"
       },
       {
         "City": "Fargo",
         "Coordinates": "46.8771863,-96.7898034"
       },
       {
         "City": "Downey",
         "Coordinates": "33.9401088,-118.1331593"
       },
       {
         "City": "Costa Mesa",
         "Coordinates": "33.6411316,-117.9186689"
       },
       {
         "City": "Wilmington",
         "Coordinates": "34.2257255,-77.9447102"
       },
       {
         "City": "Arvada",
         "Coordinates": "39.8027644,-105.0874842"
       },
       {
         "City": "Inglewood",
         "Coordinates": "33.9616801,-118.3531311"
       },
       {
         "City": "Miami Gardens",
         "Coordinates": "25.9420377,-80.2456045"
       },
       {
         "City": "Carlsbad",
         "Coordinates": "33.1580933,-117.3505939"
       },
       {
         "City": "Westminster",
         "Coordinates": "39.8366528,-105.0372046"
       },
       {
         "City": "Rochester",
         "Coordinates": "44.0121221,-92.4801989"
       },
       {
         "City": "Odessa",
         "Coordinates": "31.8456816,-102.3676431"
       },
       {
         "City": "Manchester",
         "Coordinates": "42.9956397,-71.4547891"
       },
       {
         "City": "Elgin",
         "Coordinates": "42.0354084,-88.2825668"
       },
       {
         "City": "West Jordan",
         "Coordinates": "40.6096698,-111.9391031"
       },
       {
         "City": "Round Rock",
         "Coordinates": "30.5082551,-97.678896"
       },
       {
         "City": "Clearwater",
         "Coordinates": "27.9658533,-82.8001026"
       },
       {
         "City": "Waterbury",
         "Coordinates": "41.5581525,-73.0514965"
       },
       {
         "City": "Gresham",
         "Coordinates": "45.5001357,-122.4302013"
       },
       {
         "City": "Fairfield",
         "Coordinates": "38.2493581,-122.0399663"
       },
       {
         "City": "Billings",
         "Coordinates": "45.7832856,-108.5006904"
       },
       {
         "City": "Lowell",
         "Coordinates": "42.6334247,-71.3161718"
       },
       {
         "City": "San Buenaventura (Ventura)",
         "Coordinates": "34.274646,-119.2290316"
       },
       {
         "City": "Pueblo",
         "Coordinates": "38.2544472,-104.6091409"
       },
       {
         "City": "High Point",
         "Coordinates": "35.9556923,-80.0053176"
       },
       {
         "City": "West Covina",
         "Coordinates": "34.0686208,-117.9389526"
       },
       {
         "City": "Richmond",
         "Coordinates": "37.9357576,-122.3477486"
       },
       {
         "City": "Murrieta",
         "Coordinates": "33.5539143,-117.2139232"
       },
       {
         "City": "Cambridge",
         "Coordinates": "42.3736158,-71.1097335"
       },
       {
         "City": "Antioch",
         "Coordinates": "38.0049214,-121.805789"
       },
       {
         "City": "Temecula",
         "Coordinates": "33.4936391,-117.1483648"
       },
       {
         "City": "Norwalk",
         "Coordinates": "33.9022367,-118.081733"
       },
       {
         "City": "Centennial",
         "Coordinates": "39.5807452,-104.8771726"
       },
       {
         "City": "Everett",
         "Coordinates": "47.9789848,-122.2020794"
       },
       {
         "City": "Wichita Falls",
         "Coordinates": "33.9137085,-98.4933873"
       },
       {
         "City": "Palm Bay",
         "Coordinates": "28.0344621,-80.5886646"
       },
       {
         "City": "Green Bay",
         "Coordinates": "44.519159,-88.019826"
       },
       {
         "City": "Daly City",
         "Coordinates": "37.6879241,-122.4702079"
       },
       {
         "City": "Burbank",
         "Coordinates": "34.1808392,-118.3089661"
       },
       {
         "City": "Richardson",
         "Coordinates": "32.9483335,-96.7298519"
       },
       {
         "City": "Pompano Beach",
         "Coordinates": "26.2378597,-80.1247667"
       },
       {
         "City": "North Charleston",
         "Coordinates": "32.8546197,-79.9748103"
       },
       {
         "City": "Broken Arrow",
         "Coordinates": "36.060949,-95.7974526"
       },
       {
         "City": "Boulder",
         "Coordinates": "40.0149856,-105.2705456"
       },
       {
         "City": "West Palm Beach",
         "Coordinates": "26.7153424,-80.0533746"
       },
       {
         "City": "Santa Maria",
         "Coordinates": "34.9530337,-120.4357191"
       },
       {
         "City": "El Cajon",
         "Coordinates": "32.7947731,-116.9625269"
       },
       {
         "City": "Davenport",
         "Coordinates": "41.5236437,-90.5776367"
       },
       {
         "City": "Rialto",
         "Coordinates": "34.1064001,-117.3703235"
       },
       {
         "City": "Las Cruces",
         "Coordinates": "32.3199396,-106.7636538"
       },
       {
         "City": "San Mateo",
         "Coordinates": "37.5629917,-122.3255254"
       },
       {
         "City": "Lewisville",
         "Coordinates": "33.046233,-96.994174"
       },
       {
         "City": "South Bend",
         "Coordinates": "41.6763545,-86.2519898"
       },
       {
         "City": "Lakeland",
         "Coordinates": "28.0394654,-81.9498042"
       },
       {
         "City": "Erie",
         "Coordinates": "42.1292241,-80.085059"
       },
       {
         "City": "Tyler",
         "Coordinates": "32.3512601,-95.3010624"
       },
       {
         "City": "Pearland",
         "Coordinates": "29.5635666,-95.2860474"
       },
       {
         "City": "College Station",
         "Coordinates": "30.627977,-96.3344068"
       },
       {
         "City": "Kenosha",
         "Coordinates": "42.5847425,-87.8211854"
       },
       {
         "City": "Sandy Springs",
         "Coordinates": "33.9304352,-84.3733147"
       },
       {
         "City": "Clovis",
         "Coordinates": "36.8252277,-119.7029194"
       },
       {
         "City": "Flint",
         "Coordinates": "43.0125274,-83.6874562"
       },
       {
         "City": "Roanoke",
         "Coordinates": "37.2709704,-79.9414266"
       },
       {
         "City": "Albany",
         "Coordinates": "42.6525793,-73.7562317"
       },
       {
         "City": "Jurupa Valley",
         "Coordinates": "33.9971974,-117.4854802"
       },
       {
         "City": "Compton",
         "Coordinates": "33.8958492,-118.2200712"
       },
       {
         "City": "San Angelo",
         "Coordinates": "31.4637723,-100.4370375"
       },
       {
         "City": "Hillsboro",
         "Coordinates": "45.5228939,-122.989827"
       },
       {
         "City": "Lawton",
         "Coordinates": "34.6035669,-98.3959291"
       },
       {
         "City": "Renton",
         "Coordinates": "47.4828776,-122.2170661"
       },
       {
         "City": "Vista",
         "Coordinates": "33.2000368,-117.2425355"
       },
       {
         "City": "Davie",
         "Coordinates": "26.0764783,-80.2521157"
       },
       {
         "City": "Greeley",
         "Coordinates": "40.4233142,-104.7091322"
       },
       {
         "City": "Mission Viejo",
         "Coordinates": "33.6000232,-117.6719953"
       },
       {
         "City": "Portsmouth",
         "Coordinates": "36.8354258,-76.2982742"
       },
       {
         "City": "Dearborn",
         "Coordinates": "42.3222599,-83.1763145"
       },
       {
         "City": "South Gate",
         "Coordinates": "33.954737,-118.2120161"
       },
       {
         "City": "Tuscaloosa",
         "Coordinates": "33.2098407,-87.5691735"
       },
       {
         "City": "Livonia",
         "Coordinates": "42.36837,-83.3527097"
       },
       {
         "City": "New Bedford",
         "Coordinates": "41.6362152,-70.934205"
       },
       {
         "City": "Vacaville",
         "Coordinates": "38.3565773,-121.9877444"
       },
       {
         "City": "Brockton",
         "Coordinates": "42.0834335,-71.0183787"
       },
       {
         "City": "Roswell",
         "Coordinates": "34.0232431,-84.3615555"
       },
       {
         "City": "Beaverton",
         "Coordinates": "45.487062,-122.8037102"
       },
       {
         "City": "Quincy",
         "Coordinates": "42.2528772,-71.0022705"
       },
       {
         "City": "Sparks",
         "Coordinates": "39.5349112,-119.7526886"
       },
       {
         "City": "Yakima",
         "Coordinates": "46.6020711,-120.5058987"
       },
       {
         "City": "Lee's Summit",
         "Coordinates": "38.9108408,-94.3821724"
       },
       {
         "City": "Federal Way",
         "Coordinates": "47.3223221,-122.3126222"
       },
       {
         "City": "Carson",
         "Coordinates": "33.8316745,-118.281693"
       },
       {
         "City": "Santa Monica",
         "Coordinates": "34.0194543,-118.4911912"
       },
       {
         "City": "Hesperia",
         "Coordinates": "34.4263886,-117.3008784"
       },
       {
         "City": "Allen",
         "Coordinates": "33.1031744,-96.6705503"
       },
       {
         "City": "Rio Rancho",
         "Coordinates": "35.2327544,-106.6630437"
       },
       {
         "City": "Yuma",
         "Coordinates": "32.6926512,-114.6276916"
       },
       {
         "City": "Westminster",
         "Coordinates": "33.7513419,-117.9939921"
       },
       {
         "City": "Orem",
         "Coordinates": "40.2968979,-111.6946475"
       },
       {
         "City": "Lynn",
         "Coordinates": "42.466763,-70.9494938"
       },
       {
         "City": "Redding",
         "Coordinates": "40.5865396,-122.3916754"
       },
       {
         "City": "Spokane Valley",
         "Coordinates": "47.6732281,-117.2393748"
       },
       {
         "City": "Miami Beach",
         "Coordinates": "25.790654,-80.1300455"
       },
       {
         "City": "League City",
         "Coordinates": "29.5074538,-95.0949303"
       },
       {
         "City": "Lawrence",
         "Coordinates": "38.9716689,-95.2352501"
       },
       {
         "City": "Santa Barbara",
         "Coordinates": "34.4208305,-119.6981901"
       },
       {
         "City": "Plantation",
         "Coordinates": "26.1275862,-80.2331036"
       },
       {
         "City": "Sandy",
         "Coordinates": "40.5649781,-111.8389726"
       },
       {
         "City": "Sunrise",
         "Coordinates": "26.1669711,-80.256595"
       },
       {
         "City": "Macon",
         "Coordinates": "32.8406946,-83.6324022"
       },
       {
         "City": "Longmont",
         "Coordinates": "40.1672068,-105.1019275"
       },
       {
         "City": "Boca Raton",
         "Coordinates": "26.3683064,-80.1289321"
       },
       {
         "City": "San Marcos",
         "Coordinates": "33.1433723,-117.1661449"
       },
       {
         "City": "Greenville",
         "Coordinates": "35.612661,-77.3663538"
       },
       {
         "City": "Waukegan",
         "Coordinates": "42.3636331,-87.8447938"
       },
       {
         "City": "Fall River",
         "Coordinates": "41.7014912,-71.1550451"
       },
       {
         "City": "Chico",
         "Coordinates": "39.7284944,-121.8374777"
       },
       {
         "City": "Newton",
         "Coordinates": "42.3370413,-71.2092214"
       },
       {
         "City": "San Leandro",
         "Coordinates": "37.7249296,-122.1560768"
       },
       {
         "City": "Reading",
         "Coordinates": "40.3356483,-75.9268747"
       },
       {
         "City": "Norwalk",
         "Coordinates": "41.117744,-73.4081575"
       },
       {
         "City": "Fort Smith",
         "Coordinates": "35.3859242,-94.3985475"
       },
       {
         "City": "Newport Beach",
         "Coordinates": "33.6189101,-117.9289469"
       },
       {
         "City": "Asheville",
         "Coordinates": "35.5950581,-82.5514869"
       },
       {
         "City": "Nashua",
         "Coordinates": "42.7653662,-71.467566"
       },
       {
         "City": "Edmond",
         "Coordinates": "35.6528323,-97.4780954"
       },
       {
         "City": "Whittier",
         "Coordinates": "33.9791793,-118.032844"
       },
       {
         "City": "Nampa",
         "Coordinates": "43.5407172,-116.5634624"
       },
       {
         "City": "Bloomington",
         "Coordinates": "44.840798,-93.2982799"
       },
       {
         "City": "Deltona",
         "Coordinates": "28.9005446,-81.2636738"
       },
       {
         "City": "Hawthorne",
         "Coordinates": "33.9164032,-118.3525748"
       },
       {
         "City": "Duluth",
         "Coordinates": "46.7866719,-92.1004852"
       },
       {
         "City": "Carmel",
         "Coordinates": "39.978371,-86.1180435"
       },
       {
         "City": "Suffolk",
         "Coordinates": "36.7282054,-76.5835621"
       },
       {
         "City": "Clifton",
         "Coordinates": "40.8584328,-74.1637553"
       },
       {
         "City": "Citrus Heights",
         "Coordinates": "38.7071247,-121.2810611"
       },
       {
         "City": "Livermore",
         "Coordinates": "37.6818745,-121.7680088"
       },
       {
         "City": "Tracy",
         "Coordinates": "37.7396513,-121.4252227"
       },
       {
         "City": "Alhambra",
         "Coordinates": "34.095287,-118.1270146"
       },
       {
         "City": "Kirkland",
         "Coordinates": "47.6814875,-122.2087353"
       },
       {
         "City": "Trenton",
         "Coordinates": "40.2170534,-74.7429384"
       },
       {
         "City": "Ogden",
         "Coordinates": "41.223,-111.9738304"
       },
       {
         "City": "Hoover",
         "Coordinates": "33.4053867,-86.8113781"
       },
       {
         "City": "Cicero",
         "Coordinates": "41.8455877,-87.7539448"
       },
       {
         "City": "Fishers",
         "Coordinates": "39.9567548,-86.01335"
       },
       {
         "City": "Sugar Land",
         "Coordinates": "29.6196787,-95.6349463"
       },
       {
         "City": "Danbury",
         "Coordinates": "41.394817,-73.4540111"
       },
       {
         "City": "Meridian",
         "Coordinates": "43.6121087,-116.3915131"
       },
       {
         "City": "Indio",
         "Coordinates": "33.7205771,-116.2155619"
       },
       {
         "City": "Concord",
         "Coordinates": "35.4087517,-80.579511"
       },
       {
         "City": "Menifee",
         "Coordinates": "33.6971468,-117.185294"
       },
       {
         "City": "Champaign",
         "Coordinates": "40.1164204,-88.2433829"
       },
       {
         "City": "Buena Park",
         "Coordinates": "33.8675143,-117.9981181"
       },
       {
         "City": "Troy",
         "Coordinates": "42.6064095,-83.1497751"
       },
       {
         "City": "O'Fallon",
         "Coordinates": "38.8106075,-90.6998477"
       },
       {
         "City": "Johns Creek",
         "Coordinates": "34.0289259,-84.198579"
       },
       {
         "City": "Bellingham",
         "Coordinates": "48.74908,-122.4781473"
       },
       {
         "City": "Westland",
         "Coordinates": "42.324204,-83.400211"
       },
       {
         "City": "Bloomington",
         "Coordinates": "39.165325,-86.5263857"
       },
       {
         "City": "Sioux City",
         "Coordinates": "42.4999942,-96.4003069"
       },
       {
         "City": "Warwick",
         "Coordinates": "41.7001009,-71.4161671"
       },
       {
         "City": "Hemet",
         "Coordinates": "33.7475203,-116.9719684"
       },
       {
         "City": "Longview",
         "Coordinates": "32.5007037,-94.7404891"
       },
       {
         "City": "Farmington Hills",
         "Coordinates": "42.4989936,-83.3677168"
       },
       {
         "City": "Bend",
         "Coordinates": "44.0581728,-121.3153096"
       },
       {
         "City": "Lakewood",
         "Coordinates": "33.8536269,-118.1339563"
       },
       {
         "City": "Merced",
         "Coordinates": "37.3021632,-120.4829677"
       },
       {
         "City": "Mission",
         "Coordinates": "26.2159066,-98.3252932"
       },
       {
         "City": "Chino",
         "Coordinates": "34.0122346,-117.688944"
       },
       {
         "City": "Redwood City",
         "Coordinates": "37.4852152,-122.2363548"
       },
       {
         "City": "Edinburg",
         "Coordinates": "26.3017374,-98.1633432"
       },
       {
         "City": "Cranston",
         "Coordinates": "41.7798226,-71.4372796"
       },
       {
         "City": "Parma",
         "Coordinates": "41.4047742,-81.7229086"
       },
       {
         "City": "New Rochelle",
         "Coordinates": "40.9114882,-73.7823549"
       },
       {
         "City": "Lake Forest",
         "Coordinates": "33.6469661,-117.689218"
       },
       {
         "City": "Napa",
         "Coordinates": "38.2975381,-122.286865"
       },
       {
         "City": "Hammond",
         "Coordinates": "41.5833688,-87.5000412"
       },
       {
         "City": "Fayetteville",
         "Coordinates": "36.0625795,-94.1574263"
       },
       {
         "City": "Bloomington",
         "Coordinates": "40.4842027,-88.9936873"
       },
       {
         "City": "Avondale",
         "Coordinates": "33.4355977,-112.3496021"
       },
       {
         "City": "Somerville",
         "Coordinates": "42.3875968,-71.0994968"
       },
       {
         "City": "Palm Coast",
         "Coordinates": "29.5844524,-81.2078699"
       },
       {
         "City": "Bryan",
         "Coordinates": "30.6743643,-96.3699632"
       },
       {
         "City": "Gary",
         "Coordinates": "41.5933696,-87.3464271"
       },
       {
         "City": "Largo",
         "Coordinates": "27.9094665,-82.7873244"
       },
       {
         "City": "Brooklyn Park",
         "Coordinates": "45.0941315,-93.3563405"
       },
       {
         "City": "Tustin",
         "Coordinates": "33.7458511,-117.826166"
       },
       {
         "City": "Racine",
         "Coordinates": "42.7261309,-87.7828523"
       },
       {
         "City": "Deerfield Beach",
         "Coordinates": "26.3184123,-80.0997657"
       },
       {
         "City": "Lynchburg",
         "Coordinates": "37.4137536,-79.1422464"
       },
       {
         "City": "Mountain View",
         "Coordinates": "37.3860517,-122.0838511"
       },
       {
         "City": "Medford",
         "Coordinates": "42.3265152,-122.8755949"
       },
       {
         "City": "Lawrence",
         "Coordinates": "42.7070354,-71.1631137"
       },
       {
         "City": "Bellflower",
         "Coordinates": "33.8816818,-118.1170117"
       },
       {
         "City": "Melbourne",
         "Coordinates": "28.0836269,-80.6081089"
       },
       {
         "City": "St. Joseph",
         "Coordinates": "39.7674578,-94.846681"
       },
       {
         "City": "Camden",
         "Coordinates": "39.9259463,-75.1196199"
       },
       {
         "City": "St. George",
         "Coordinates": "37.0965278,-113.5684164"
       },
       {
         "City": "Kennewick",
         "Coordinates": "46.2112458,-119.1372338"
       },
       {
         "City": "Baldwin Park",
         "Coordinates": "34.0852868,-117.9608978"
       },
       {
         "City": "Chino Hills",
         "Coordinates": "33.9898188,-117.7325848"
       },
       {
         "City": "Alameda",
         "Coordinates": "37.7652065,-122.2416355"
       },
       {
         "City": "Albany",
         "Coordinates": "31.5785074,-84.155741"
       },
       {
         "City": "Arlington Heights",
         "Coordinates": "42.0883603,-87.9806265"
       },
       {
         "City": "Scranton",
         "Coordinates": "41.408969,-75.6624122"
       },
       {
         "City": "Evanston",
         "Coordinates": "42.0450722,-87.6876969"
       },
       {
         "City": "Kalamazoo",
         "Coordinates": "42.2917069,-85.5872286"
       },
       {
         "City": "Baytown",
         "Coordinates": "29.7355047,-94.9774274"
       },
       {
         "City": "Upland",
         "Coordinates": "34.09751,-117.6483876"
       },
       {
         "City": "Springdale",
         "Coordinates": "36.1867442,-94.1288141"
       },
       {
         "City": "Bethlehem",
         "Coordinates": "40.6259316,-75.3704579"
       },
       {
         "City": "Schaumburg",
         "Coordinates": "42.0333607,-88.0834059"
       },
       {
         "City": "Mount Pleasant",
         "Coordinates": "32.8323225,-79.8284258"
       },
       {
         "City": "Auburn",
         "Coordinates": "47.3073228,-122.2284532"
       },
       {
         "City": "Decatur",
         "Coordinates": "39.8403147,-88.9548001"
       },
       {
         "City": "San Ramon",
         "Coordinates": "37.7799273,-121.9780153"
       },
       {
         "City": "Pleasanton",
         "Coordinates": "37.6624312,-121.8746789"
       },
       {
         "City": "Wyoming",
         "Coordinates": "42.9133602,-85.7053085"
       },
       {
         "City": "Lake Charles",
         "Coordinates": "30.2265949,-93.2173758"
       },
       {
         "City": "Plymouth",
         "Coordinates": "45.0105194,-93.4555093"
       },
       {
         "City": "Bolingbrook",
         "Coordinates": "41.6986416,-88.0683955"
       },
       {
         "City": "Pharr",
         "Coordinates": "26.1947962,-98.1836216"
       },
       {
         "City": "Appleton",
         "Coordinates": "44.2619309,-88.4153847"
       },
       {
         "City": "Gastonia",
         "Coordinates": "35.262082,-81.1873005"
       },
       {
         "City": "Folsom",
         "Coordinates": "38.6779591,-121.1760583"
       },
       {
         "City": "Southfield",
         "Coordinates": "42.4733688,-83.2218731"
       },
       {
         "City": "Rochester Hills",
         "Coordinates": "42.6583661,-83.1499322"
       },
       {
         "City": "New Britain",
         "Coordinates": "41.6612104,-72.7795419"
       },
       {
         "City": "Goodyear",
         "Coordinates": "33.4353394,-112.3576567"
       },
       {
         "City": "Canton",
         "Coordinates": "40.7989473,-81.378447"
       },
       {
         "City": "Warner Robins",
         "Coordinates": "32.6130007,-83.624201"
       },
       {
         "City": "Union City",
         "Coordinates": "37.5933918,-122.0438298"
       },
       {
         "City": "Perris",
         "Coordinates": "33.7825194,-117.2286478"
       },
       {
         "City": "Manteca",
         "Coordinates": "37.7974273,-121.2160526"
       },
       {
         "City": "Iowa City",
         "Coordinates": "41.6611277,-91.5301683"
       },
       {
         "City": "Jonesboro",
         "Coordinates": "35.8422967,-90.704279"
       },
       {
         "City": "Wilmington",
         "Coordinates": "39.7390721,-75.5397878"
       },
       {
         "City": "Lynwood",
         "Coordinates": "33.930293,-118.2114603"
       },
       {
         "City": "Loveland",
         "Coordinates": "40.3977612,-105.0749801"
       },
       {
         "City": "Pawtucket",
         "Coordinates": "41.878711,-71.3825558"
       },
       {
         "City": "Boynton Beach",
         "Coordinates": "26.5317866,-80.0905465"
       },
       {
         "City": "Waukesha",
         "Coordinates": "43.0116784,-88.2314813"
       },
       {
         "City": "Gulfport",
         "Coordinates": "30.3674198,-89.0928155"
       },
       {
         "City": "Apple Valley",
         "Coordinates": "34.5008311,-117.1858759"
       },
       {
         "City": "Passaic",
         "Coordinates": "40.8567662,-74.1284764"
       },
       {
         "City": "Rapid City",
         "Coordinates": "44.0805434,-103.2310149"
       },
       {
         "City": "Layton",
         "Coordinates": "41.0602216,-111.9710529"
       },
       {
         "City": "Lafayette",
         "Coordinates": "40.4167022,-86.8752869"
       },
       {
         "City": "Turlock",
         "Coordinates": "37.4946568,-120.8465941"
       },
       {
         "City": "Muncie",
         "Coordinates": "40.1933767,-85.3863599"
       },
       {
         "City": "Temple",
         "Coordinates": "31.0982344,-97.342782"
       },
       {
         "City": "Missouri City",
         "Coordinates": "29.6185669,-95.5377215"
       },
       {
         "City": "Redlands",
         "Coordinates": "34.0555693,-117.1825381"
       },
       {
         "City": "Santa Fe",
         "Coordinates": "35.6869752,-105.937799"
       },
       {
         "City": "Lauderhill",
         "Coordinates": "26.1403635,-80.2133808"
       },
       {
         "City": "Milpitas",
         "Coordinates": "37.4323341,-121.8995741"
       },
       {
         "City": "Palatine",
         "Coordinates": "42.1103041,-88.03424"
       },
       {
         "City": "Missoula",
         "Coordinates": "46.8787176,-113.996586"
       },
       {
         "City": "Rock Hill",
         "Coordinates": "34.9248667,-81.0250784"
       },
       {
         "City": "Jacksonville",
         "Coordinates": "34.7540524,-77.4302414"
       },
       {
         "City": "Franklin",
         "Coordinates": "35.9250637,-86.8688899"
       },
       {
         "City": "Flagstaff",
         "Coordinates": "35.1982836,-111.651302"
       },
       {
         "City": "Flower Mound",
         "Coordinates": "33.0145673,-97.0969552"
       },
       {
         "City": "Weston",
         "Coordinates": "26.1003654,-80.3997748"
       },
       {
         "City": "Waterloo",
         "Coordinates": "42.492786,-92.3425775"
       },
       {
         "City": "Union City",
         "Coordinates": "40.6975898,-74.2631635"
       },
       {
         "City": "Mount Vernon",
         "Coordinates": "40.9125992,-73.8370786"
       },
       {
         "City": "Fort Myers",
         "Coordinates": "26.640628,-81.8723084"
       },
       {
         "City": "Dothan",
         "Coordinates": "31.2232313,-85.3904888"
       },
       {
         "City": "Rancho Cordova",
         "Coordinates": "38.5890723,-121.302728"
       },
       {
         "City": "Redondo Beach",
         "Coordinates": "33.8491816,-118.3884078"
       },
       {
         "City": "Jackson",
         "Coordinates": "35.6145169,-88.8139469"
       },
       {
         "City": "Pasco",
         "Coordinates": "46.2395793,-119.1005657"
       },
       {
         "City": "St. Charles",
         "Coordinates": "38.7881062,-90.4974359"
       },
       {
         "City": "Eau Claire",
         "Coordinates": "44.811349,-91.4984941"
       },
       {
         "City": "North Richland Hills",
         "Coordinates": "32.8342952,-97.2289029"
       },
       {
         "City": "Bismarck",
         "Coordinates": "46.8083268,-100.7837392"
       },
       {
         "City": "Yorba Linda",
         "Coordinates": "33.8886259,-117.8131125"
       },
       {
         "City": "Kenner",
         "Coordinates": "29.9940924,-90.2417434"
       },
       {
         "City": "Walnut Creek",
         "Coordinates": "37.9100783,-122.0651819"
       },
       {
         "City": "Frederick",
         "Coordinates": "39.4142688,-77.4105409"
       },
       {
         "City": "Oshkosh",
         "Coordinates": "44.0247062,-88.5426136"
       },
       {
         "City": "Pittsburg",
         "Coordinates": "38.0279762,-121.8846806"
       },
       {
         "City": "Palo Alto",
         "Coordinates": "37.4418834,-122.1430195"
       },
       {
         "City": "Bossier City",
         "Coordinates": "32.5159852,-93.7321228"
       },
       {
         "City": "Portland",
         "Coordinates": "43.661471,-70.2553259"
       },
       {
         "City": "St. Cloud",
         "Coordinates": "45.5579451,-94.1632404"
       },
       {
         "City": "Davis",
         "Coordinates": "38.5449065,-121.7405167"
       },
       {
         "City": "South San Francisco",
         "Coordinates": "37.654656,-122.4077498"
       },
       {
         "City": "Camarillo",
         "Coordinates": "34.2163937,-119.0376023"
       },
       {
         "City": "North Little Rock",
         "Coordinates": "34.769536,-92.2670941"
       },
       {
         "City": "Schenectady",
         "Coordinates": "42.8142432,-73.9395687"
       },
       {
         "City": "Gaithersburg",
         "Coordinates": "39.1434406,-77.2013705"
       },
       {
         "City": "Harlingen",
         "Coordinates": "26.1906306,-97.6961026"
       },
       {
         "City": "Woodbury",
         "Coordinates": "44.9238552,-92.9593797"
       },
       {
         "City": "Eagan",
         "Coordinates": "44.8041322,-93.1668858"
       },
       {
         "City": "Yuba City",
         "Coordinates": "39.1404477,-121.6169108"
       },
       {
         "City": "Maple Grove",
         "Coordinates": "45.0724642,-93.4557877"
       },
       {
         "City": "Youngstown",
         "Coordinates": "41.0997803,-80.6495194"
       },
       {
         "City": "Skokie",
         "Coordinates": "42.0324025,-87.7416246"
       },
       {
         "City": "Kissimmee",
         "Coordinates": "28.2919557,-81.407571"
       },
       {
         "City": "Johnson City",
         "Coordinates": "36.3134397,-82.3534727"
       },
       {
         "City": "Victoria",
         "Coordinates": "28.8052674,-97.0035982"
       },
       {
         "City": "San Clemente",
         "Coordinates": "33.4269728,-117.6119925"
       },
       {
         "City": "Bayonne",
         "Coordinates": "40.6687141,-74.1143091"
       },
       {
         "City": "Laguna Niguel",
         "Coordinates": "33.5225261,-117.7075526"
       },
       {
         "City": "East Orange",
         "Coordinates": "40.767323,-74.2048677"
       },
       {
         "City": "Shawnee",
         "Coordinates": "39.0228485,-94.7151865"
       },
       {
         "City": "Homestead",
         "Coordinates": "25.4687224,-80.4775569"
       },
       {
         "City": "Rockville",
         "Coordinates": "39.0839973,-77.1527578"
       },
       {
         "City": "Delray Beach",
         "Coordinates": "26.4614625,-80.0728201"
       },
       {
         "City": "Janesville",
         "Coordinates": "42.6827885,-89.0187222"
       },
       {
         "City": "Conway",
         "Coordinates": "35.0886963,-92.4421011"
       },
       {
         "City": "Pico Rivera",
         "Coordinates": "33.9830688,-118.096735"
       },
       {
         "City": "Lorain",
         "Coordinates": "41.452819,-82.1823746"
       },
       {
         "City": "Montebello",
         "Coordinates": "34.0165053,-118.1137535"
       },
       {
         "City": "Lodi",
         "Coordinates": "38.1341477,-121.2722194"
       },
       {
         "City": "New Braunfels",
         "Coordinates": "29.7030024,-98.1244531"
       },
       {
         "City": "Marysville",
         "Coordinates": "48.0517637,-122.1770818"
       },
       {
         "City": "Tamarac",
         "Coordinates": "26.2128609,-80.2497707"
       },
       {
         "City": "Madera",
         "Coordinates": "36.9613356,-120.0607176"
       },
       {
         "City": "Conroe",
         "Coordinates": "30.3118769,-95.4560512"
       },
       {
         "City": "Santa Cruz",
         "Coordinates": "36.9741171,-122.0307963"
       },
       {
         "City": "Eden Prairie",
         "Coordinates": "44.8546856,-93.470786"
       },
       {
         "City": "Cheyenne",
         "Coordinates": "41.1399814,-104.8202462"
       },
       {
         "City": "Daytona Beach",
         "Coordinates": "29.2108147,-81.0228331"
       },
       {
         "City": "Alpharetta",
         "Coordinates": "34.0753762,-84.2940899"
       },
       {
         "City": "Hamilton",
         "Coordinates": "39.3995008,-84.5613355"
       },
       {
         "City": "Waltham",
         "Coordinates": "42.3764852,-71.2356113"
       },
       {
         "City": "Coon Rapids",
         "Coordinates": "45.1732394,-93.3030063"
       },
       {
         "City": "Haverhill",
         "Coordinates": "42.7762015,-71.0772796"
       },
       {
         "City": "Council Bluffs",
         "Coordinates": "41.2619444,-95.8608333"
       },
       {
         "City": "Taylor",
         "Coordinates": "42.240872,-83.2696509"
       },
       {
         "City": "Utica",
         "Coordinates": "43.100903,-75.232664"
       },
       {
         "City": "Ames",
         "Coordinates": "42.034722,-93.62"
       },
       {
         "City": "La Habra",
         "Coordinates": "33.9319578,-117.9461734"
       },
       {
         "City": "Encinitas",
         "Coordinates": "33.0369867,-117.2919818"
       },
       {
         "City": "Bowling Green",
         "Coordinates": "36.9685219,-86.4808043"
       },
       {
         "City": "Burnsville",
         "Coordinates": "44.7677424,-93.2777226"
       },
       {
         "City": "Greenville",
         "Coordinates": "34.8526176,-82.3940104"
       },
       {
         "City": "West Des Moines",
         "Coordinates": "41.5772115,-93.711332"
       },
       {
         "City": "Cedar Park",
         "Coordinates": "30.505198,-97.8202888"
       },
       {
         "City": "Tulare",
         "Coordinates": "36.2077288,-119.3473379"
       },
       {
         "City": "Monterey Park",
         "Coordinates": "34.0625106,-118.1228476"
       },
       {
         "City": "Vineland",
         "Coordinates": "39.4863773,-75.0259637"
       },
       {
         "City": "Terre Haute",
         "Coordinates": "39.4667034,-87.4139092"
       },
       {
         "City": "North Miami",
         "Coordinates": "25.8900949,-80.1867138"
       },
       {
         "City": "Mansfield",
         "Coordinates": "32.5631924,-97.1416768"
       },
       {
         "City": "West Allis",
         "Coordinates": "43.0166806,-88.0070315"
       },
       {
         "City": "Bristol",
         "Coordinates": "41.6717648,-72.9492703"
       },
       {
         "City": "Taylorsville",
         "Coordinates": "40.6677248,-111.9388258"
       },
       {
         "City": "Malden",
         "Coordinates": "42.4250964,-71.066163"
       },
       {
         "City": "Meriden",
         "Coordinates": "41.5381535,-72.8070435"
       },
       {
         "City": "Blaine",
         "Coordinates": "45.1607987,-93.2349489"
       },
       {
         "City": "Wellington",
         "Coordinates": "26.6617635,-80.2683571"
       },
       {
         "City": "Cupertino",
         "Coordinates": "37.3229978,-122.0321823"
       },
       {
         "City": "Springfield",
         "Coordinates": "44.0462362,-123.0220289"
       },
       {
         "City": "Rogers",
         "Coordinates": "36.3320196,-94.1185366"
       },
       {
         "City": "St. Clair Shores",
         "Coordinates": "42.4974085,-82.8963604"
       },
       {
         "City": "Gardena",
         "Coordinates": "33.8883487,-118.3089624"
       },
       {
         "City": "Pontiac",
         "Coordinates": "42.6389216,-83.2910468"
       },
       {
         "City": "National City",
         "Coordinates": "32.6781085,-117.0991967"
       },
       {
         "City": "Grand Junction",
         "Coordinates": "39.0638705,-108.5506486"
       },
       {
         "City": "Rocklin",
         "Coordinates": "38.7907339,-121.2357828"
       },
       {
         "City": "Chapel Hill",
         "Coordinates": "35.9131996,-79.0558445"
       },
       {
         "City": "Casper",
         "Coordinates": "42.866632,-106.313081"
       },
       {
         "City": "Broomfield",
         "Coordinates": "39.9205411,-105.0866504"
       },
       {
         "City": "Petaluma",
         "Coordinates": "38.232417,-122.6366524"
       },
       {
         "City": "South Jordan",
         "Coordinates": "40.5621704,-111.929658"
       },
       {
         "City": "Springfield",
         "Coordinates": "39.9242266,-83.8088171"
       },
       {
         "City": "Great Falls",
         "Coordinates": "47.4941836,-111.2833449"
       },
       {
         "City": "Lancaster",
         "Coordinates": "40.0378755,-76.3055144"
       },
       {
         "City": "North Port",
         "Coordinates": "27.044224,-82.2359254"
       },
       {
         "City": "Lakewood",
         "Coordinates": "47.1717649,-122.518458"
       },
       {
         "City": "Marietta",
         "Coordinates": "33.952602,-84.5499327"
       },
       {
         "City": "San Rafael",
         "Coordinates": "37.9735346,-122.5310874"
       },
       {
         "City": "Royal Oak",
         "Coordinates": "42.4894801,-83.1446485"
       },
       {
         "City": "Des Plaines",
         "Coordinates": "42.0333623,-87.8833991"
       },
       {
         "City": "Huntington Park",
         "Coordinates": "33.9816812,-118.2250725"
       },
       {
         "City": "La Mesa",
         "Coordinates": "32.7678287,-117.0230839"
       },
       {
         "City": "Orland Park",
         "Coordinates": "41.6303103,-87.8539425"
       },
       {
         "City": "Auburn",
         "Coordinates": "32.6098566,-85.4807825"
       },
       {
         "City": "Lakeville",
         "Coordinates": "44.6496868,-93.24272"
       },
       {
         "City": "Owensboro",
         "Coordinates": "37.7719074,-87.1111676"
       },
       {
         "City": "Moore",
         "Coordinates": "35.3395079,-97.4867028"
       },
       {
         "City": "Jupiter",
         "Coordinates": "26.9342246,-80.0942087"
       },
       {
         "City": "Idaho Falls",
         "Coordinates": "43.4916514,-112.0339645"
       },
       {
         "City": "Dubuque",
         "Coordinates": "42.5005583,-90.6645718"
       },
       {
         "City": "Bartlett",
         "Coordinates": "35.2045328,-89.8739753"
       },
       {
         "City": "Rowlett",
         "Coordinates": "32.9029017,-96.56388"
       },
       {
         "City": "Novi",
         "Coordinates": "42.48059,-83.4754913"
       },
       {
         "City": "White Plains",
         "Coordinates": "41.0339862,-73.7629097"
       },
       {
         "City": "Arcadia",
         "Coordinates": "34.1397292,-118.0353449"
       },
       {
         "City": "Redmond",
         "Coordinates": "47.6739881,-122.121512"
       },
       {
         "City": "Lake Elsinore",
         "Coordinates": "33.6680772,-117.3272615"
       },
       {
         "City": "Ocala",
         "Coordinates": "29.1871986,-82.1400923"
       },
       {
         "City": "Tinley Park",
         "Coordinates": "41.5731442,-87.7932939"
       },
       {
         "City": "Port Orange",
         "Coordinates": "29.1383165,-80.9956105"
       },
       {
         "City": "Medford",
         "Coordinates": "42.4184296,-71.1061639"
       },
       {
         "City": "Oak Lawn",
         "Coordinates": "41.719978,-87.7479528"
       },
       {
         "City": "Rocky Mount",
         "Coordinates": "35.9382103,-77.7905339"
       },
       {
         "City": "Kokomo",
         "Coordinates": "40.486427,-86.1336033"
       },
       {
         "City": "Coconut Creek",
         "Coordinates": "26.2517482,-80.1789351"
       },
       {
         "City": "Bowie",
         "Coordinates": "39.0067768,-76.7791365"
       },
       {
         "City": "Berwyn",
         "Coordinates": "41.8505874,-87.7936685"
       },
       {
         "City": "Midwest City",
         "Coordinates": "35.4495065,-97.3967019"
       },
       {
         "City": "Fountain Valley",
         "Coordinates": "33.7091847,-117.9536697"
       },
       {
         "City": "Buckeye",
         "Coordinates": "33.3703197,-112.5837766"
       },
       {
         "City": "Dearborn Heights",
         "Coordinates": "42.3369816,-83.2732627"
       },
       {
         "City": "Woodland",
         "Coordinates": "38.6785157,-121.7732971"
       },
       {
         "City": "Noblesville",
         "Coordinates": "40.0455917,-86.0085955"
       },
       {
         "City": "Valdosta",
         "Coordinates": "30.8327022,-83.2784851"
       },
       {
         "City": "Diamond Bar",
         "Coordinates": "34.0286226,-117.8103367"
       },
       {
         "City": "Manhattan",
         "Coordinates": "39.1836082,-96.5716694"
       },
       {
         "City": "Santee",
         "Coordinates": "32.8383828,-116.9739167"
       },
       {
         "City": "Taunton",
         "Coordinates": "41.900101,-71.0897674"
       },
       {
         "City": "Sanford",
         "Coordinates": "28.8028612,-81.269453"
       },
       {
         "City": "Kettering",
         "Coordinates": "39.6895036,-84.1688274"
       },
       {
         "City": "New Brunswick",
         "Coordinates": "40.4862157,-74.4518188"
       },
       {
         "City": "Decatur",
         "Coordinates": "34.6059253,-86.9833417"
       },
       {
         "City": "Chicopee",
         "Coordinates": "42.1487043,-72.6078672"
       },
       {
         "City": "Anderson",
         "Coordinates": "40.1053196,-85.6802541"
       },
       {
         "City": "Margate",
         "Coordinates": "26.2445263,-80.206436"
       },
       {
         "City": "Weymouth Town",
         "Coordinates": "42.2180724,-70.9410356"
       },
       {
         "City": "Hempstead",
         "Coordinates": "40.7062128,-73.6187397"
       },
       {
         "City": "Corvallis",
         "Coordinates": "44.5645659,-123.2620435"
       },
       {
         "City": "Eastvale",
         "Coordinates": "33.952463,-117.5848025"
       },
       {
         "City": "Porterville",
         "Coordinates": "36.06523,-119.0167679"
       },
       {
         "City": "West Haven",
         "Coordinates": "41.2705484,-72.9469711"
       },
       {
         "City": "Brentwood",
         "Coordinates": "37.931868,-121.6957863"
       },
       {
         "City": "Paramount",
         "Coordinates": "33.8894598,-118.1597911"
       },
       {
         "City": "Grand Forks",
         "Coordinates": "47.9252568,-97.0328547"
       },
       {
         "City": "Georgetown",
         "Coordinates": "30.6332618,-97.6779842"
       },
       {
         "City": "St. Peters",
         "Coordinates": "38.7874699,-90.6298922"
       },
       {
         "City": "Shoreline",
         "Coordinates": "47.7556531,-122.3415178"
       },
       {
         "City": "Mount Prospect",
         "Coordinates": "42.0664167,-87.9372908"
       },
       {
         "City": "Hanford",
         "Coordinates": "36.3274502,-119.6456844"
       },
       {
         "City": "Normal",
         "Coordinates": "40.5142026,-88.9906312"
       },
       {
         "City": "Rosemead",
         "Coordinates": "34.0805651,-118.072846"
       },
       {
         "City": "Lehi",
         "Coordinates": "40.3916172,-111.8507662"
       },
       {
         "City": "Pocatello",
         "Coordinates": "42.8713032,-112.4455344"
       },
       {
         "City": "Highland",
         "Coordinates": "34.1283442,-117.2086513"
       },
       {
         "City": "Novato",
         "Coordinates": "38.1074198,-122.5697032"
       },
       {
         "City": "Port Arthur",
         "Coordinates": "29.8849504,-93.939947"
       },
       {
         "City": "Carson City",
         "Coordinates": "39.1637984,-119.7674034"
       },
       {
         "City": "San Marcos",
         "Coordinates": "29.8832749,-97.9413941"
       },
       {
         "City": "Hendersonville",
         "Coordinates": "36.3047735,-86.6199957"
       },
       {
         "City": "Elyria",
         "Coordinates": "41.3683798,-82.1076486"
       },
       {
         "City": "Revere",
         "Coordinates": "42.4084302,-71.0119948"
       },
       {
         "City": "Pflugerville",
         "Coordinates": "30.4393696,-97.6200043"
       },
       {
         "City": "Greenwood",
         "Coordinates": "39.6136578,-86.1066526"
       },
       {
         "City": "Bellevue",
         "Coordinates": "41.1543623,-95.9145568"
       },
       {
         "City": "Wheaton",
         "Coordinates": "41.8661403,-88.1070127"
       },
       {
         "City": "Smyrna",
         "Coordinates": "33.8839926,-84.5143761"
       },
       {
         "City": "Sarasota",
         "Coordinates": "27.3364347,-82.5306527"
       },
       {
         "City": "Blue Springs",
         "Coordinates": "39.0169509,-94.2816148"
       },
       {
         "City": "Colton",
         "Coordinates": "34.0739016,-117.3136547"
       },
       {
         "City": "Euless",
         "Coordinates": "32.8370727,-97.0819541"
       },
       {
         "City": "Castle Rock",
         "Coordinates": "39.3722121,-104.8560902"
       },
       {
         "City": "Cathedral City",
         "Coordinates": "33.7805388,-116.4668036"
       },
       {
         "City": "Kingsport",
         "Coordinates": "36.548434,-82.5618186"
       },
       {
         "City": "Lake Havasu City",
         "Coordinates": "34.483901,-114.3224548"
       },
       {
         "City": "Pensacola",
         "Coordinates": "30.421309,-87.2169149"
       },
       {
         "City": "Hoboken",
         "Coordinates": "40.7439905,-74.0323626"
       },
       {
         "City": "Yucaipa",
         "Coordinates": "34.033625,-117.0430865"
       },
       {
         "City": "Watsonville",
         "Coordinates": "36.910231,-121.7568946"
       },
       {
         "City": "Richland",
         "Coordinates": "46.2856907,-119.2844621"
       },
       {
         "City": "Delano",
         "Coordinates": "35.7688425,-119.2470536"
       },
       {
         "City": "Hoffman Estates",
         "Coordinates": "42.0629915,-88.1227199"
       },
       {
         "City": "Florissant",
         "Coordinates": "38.789217,-90.322614"
       },
       {
         "City": "Placentia",
         "Coordinates": "33.8722371,-117.8703363"
       },
       {
         "City": "West New York",
         "Coordinates": "40.7878788,-74.0143064"
       },
       {
         "City": "Dublin",
         "Coordinates": "37.7021521,-121.9357918"
       },
       {
         "City": "Oak Park",
         "Coordinates": "41.8850317,-87.7845025"
       },
       {
         "City": "Peabody",
         "Coordinates": "42.5278731,-70.9286609"
       },
       {
         "City": "Perth Amboy",
         "Coordinates": "40.5067723,-74.2654234"
       },
       {
         "City": "Battle Creek",
         "Coordinates": "42.3211522,-85.1797142"
       },
       {
         "City": "Bradenton",
         "Coordinates": "27.4989278,-82.5748194"
       },
       {
         "City": "Gilroy",
         "Coordinates": "37.0057816,-121.5682751"
       },
       {
         "City": "Milford",
         "Coordinates": "41.2306979,-73.064036"
       },
       {
         "City": "Albany",
         "Coordinates": "44.6365107,-123.1059282"
       },
       {
         "City": "Ankeny",
         "Coordinates": "41.7317884,-93.6001278"
       },
       {
         "City": "La Crosse",
         "Coordinates": "43.8013556,-91.2395807"
       },
       {
         "City": "Burlington",
         "Coordinates": "36.0956918,-79.4377991"
       },
       {
         "City": "DeSoto",
         "Coordinates": "32.5896998,-96.8570738"
       },
       {
         "City": "Harrisonburg",
         "Coordinates": "38.4495688,-78.8689155"
       },
       {
         "City": "Minnetonka",
         "Coordinates": "44.9211836,-93.4687489"
       },
       {
         "City": "Elkhart",
         "Coordinates": "41.6819935,-85.9766671"
       },
       {
         "City": "Lakewood",
         "Coordinates": "41.4819932,-81.7981908"
       },
       {
         "City": "Glendora",
         "Coordinates": "34.1361187,-117.865339"
       },
       {
         "City": "Southaven",
         "Coordinates": "34.9889818,-90.0125913"
       },
       {
         "City": "Charleston",
         "Coordinates": "38.3498195,-81.6326234"
       },
       {
         "City": "Joplin",
         "Coordinates": "37.0842271,-94.513281"
       },
       {
         "City": "Enid",
         "Coordinates": "36.3955891,-97.8783911"
       },
       {
         "City": "Palm Beach Gardens",
         "Coordinates": "26.8233946,-80.1386547"
       },
       {
         "City": "Brookhaven",
         "Coordinates": "33.8651033,-84.3365917"
       },
       {
         "City": "Plainfield",
         "Coordinates": "40.6337136,-74.4073736"
       },
       {
         "City": "Grand Island",
         "Coordinates": "40.9263957,-98.3420118"
       },
       {
         "City": "Palm Desert",
         "Coordinates": "33.7222445,-116.3744556"
       },
       {
         "City": "Huntersville",
         "Coordinates": "35.410694,-80.8428504"
       },
       {
         "City": "Tigard",
         "Coordinates": "45.4312294,-122.7714861"
       },
       {
         "City": "Lenexa",
         "Coordinates": "38.9536174,-94.7335709"
       },
       {
         "City": "Saginaw",
         "Coordinates": "43.4194699,-83.9508068"
       },
       {
         "City": "Kentwood",
         "Coordinates": "42.8694731,-85.6447492"
       },
       {
         "City": "Doral",
         "Coordinates": "25.8195424,-80.3553302"
       },
       {
         "City": "Apple Valley",
         "Coordinates": "44.7319094,-93.21772"
       },
       {
         "City": "Grapevine",
         "Coordinates": "32.9342919,-97.0780654"
       },
       {
         "City": "Aliso Viejo",
         "Coordinates": "33.5676842,-117.7256083"
       },
       {
         "City": "Sammamish",
         "Coordinates": "47.6162683,-122.0355736"
       },
       {
         "City": "Casa Grande",
         "Coordinates": "32.8795022,-111.7573521"
       },
       {
         "City": "Pinellas Park",
         "Coordinates": "27.8428025,-82.6995443"
       },
       {
         "City": "Troy",
         "Coordinates": "42.7284117,-73.6917851"
       },
       {
         "City": "West Sacramento",
         "Coordinates": "38.5804609,-121.530234"
       },
       {
         "City": "Burien",
         "Coordinates": "47.4703767,-122.3467918"
       },
       {
         "City": "Commerce City",
         "Coordinates": "39.8083196,-104.9338675"
       },
       {
         "City": "Monroe",
         "Coordinates": "32.5093109,-92.1193012"
       },
       {
         "City": "Cerritos",
         "Coordinates": "33.8583483,-118.0647871"
       },
       {
         "City": "Downers Grove",
         "Coordinates": "41.8089191,-88.0111746"
       },
       {
         "City": "Coral Gables",
         "Coordinates": "25.72149,-80.2683838"
       },
       {
         "City": "Wilson",
         "Coordinates": "35.7212689,-77.9155395"
       },
       {
         "City": "Niagara Falls",
         "Coordinates": "43.0962143,-79.0377388"
       },
       {
         "City": "Poway",
         "Coordinates": "32.9628232,-117.0358646"
       },
       {
         "City": "Edina",
         "Coordinates": "44.8896866,-93.3499489"
       },
       {
         "City": "Cuyahoga Falls",
         "Coordinates": "41.1339449,-81.4845585"
       },
       {
         "City": "Rancho Santa Margarita",
         "Coordinates": "33.640855,-117.603104"
       },
       {
         "City": "Harrisburg",
         "Coordinates": "40.2731911,-76.8867008"
       },
       {
         "City": "Huntington",
         "Coordinates": "38.4192496,-82.445154"
       },
       {
         "City": "La Mirada",
         "Coordinates": "33.9172357,-118.0120086"
       },
       {
         "City": "Cypress",
         "Coordinates": "33.8169599,-118.0372852"
       },
       {
         "City": "Caldwell",
         "Coordinates": "43.6629384,-116.6873596"
       },
       {
         "City": "Logan",
         "Coordinates": "41.7369803,-111.8338359"
       },
       {
         "City": "Galveston",
         "Coordinates": "29.3013479,-94.7976958"
       },
       {
         "City": "Sheboygan",
         "Coordinates": "43.7508284,-87.71453"
       },
       {
         "City": "Middletown",
         "Coordinates": "39.5150576,-84.3982763"
       },
       {
         "City": "Murray",
         "Coordinates": "40.6668916,-111.8879909"
       },
       {
         "City": "Roswell",
         "Coordinates": "33.3942655,-104.5230242"
       },
       {
         "City": "Parker",
         "Coordinates": "39.5186002,-104.7613633"
       },
       {
         "City": "Bedford",
         "Coordinates": "32.844017,-97.1430671"
       },
       {
         "City": "East Lansing",
         "Coordinates": "42.7369792,-84.4838654"
       },
       {
         "City": "Methuen",
         "Coordinates": "42.7262016,-71.1908924"
       },
       {
         "City": "Covina",
         "Coordinates": "34.0900091,-117.8903397"
       },
       {
         "City": "Alexandria",
         "Coordinates": "31.3112936,-92.4451371"
       },
       {
         "City": "Olympia",
         "Coordinates": "47.0378741,-122.9006951"
       },
       {
         "City": "Euclid",
         "Coordinates": "41.5931049,-81.5267873"
       },
       {
         "City": "Mishawaka",
         "Coordinates": "41.6619927,-86.1586156"
       },
       {
         "City": "Salina",
         "Coordinates": "38.8402805,-97.6114237"
       },
       {
         "City": "Azusa",
         "Coordinates": "34.1336186,-117.9075627"
       },
       {
         "City": "Newark",
         "Coordinates": "40.0581205,-82.4012642"
       },
       {
         "City": "Chesterfield",
         "Coordinates": "38.6631083,-90.5770675"
       },
       {
         "City": "Leesburg",
         "Coordinates": "39.1156615,-77.5636015"
       },
       {
         "City": "Dunwoody",
         "Coordinates": "33.9462125,-84.3346473"
       },
       {
         "City": "Hattiesburg",
         "Coordinates": "31.3271189,-89.2903392"
       },
       {
         "City": "Roseville",
         "Coordinates": "42.4972583,-82.9371409"
       },
       {
         "City": "Bonita Springs",
         "Coordinates": "26.339806,-81.7786972"
       },
       {
         "City": "Portage",
         "Coordinates": "42.2011538,-85.5800022"
       },
       {
         "City": "St. Louis Park",
         "Coordinates": "44.9597376,-93.3702186"
       },
       {
         "City": "Collierville",
         "Coordinates": "35.042036,-89.6645266"
       },
       {
         "City": "Middletown",
         "Coordinates": "41.5623209,-72.6506488"
       },
       {
         "City": "Stillwater",
         "Coordinates": "36.1156071,-97.0583681"
       },
       {
         "City": "East Providence",
         "Coordinates": "41.8137116,-71.3700545"
       },
       {
         "City": "Lawrence",
         "Coordinates": "39.8386516,-86.0252612"
       },
       {
         "City": "Wauwatosa",
         "Coordinates": "43.0494572,-88.0075875"
       },
       {
         "City": "Mentor",
         "Coordinates": "41.6661573,-81.339552"
       },
       {
         "City": "Ceres",
         "Coordinates": "37.5949316,-120.9577098"
       },
       {
         "City": "Cedar Hill",
         "Coordinates": "32.5884689,-96.9561152"
       },
       {
         "City": "Mansfield",
         "Coordinates": "40.75839,-82.5154471"
       },
       {
         "City": "Binghamton",
         "Coordinates": "42.0986867,-75.9179738"
       },
       {
         "City": "Coeur d'Alene",
         "Coordinates": "47.6776832,-116.7804664"
       },
       {
         "City": "San Luis Obispo",
         "Coordinates": "35.2827524,-120.6596156"
       },
       {
         "City": "Minot",
         "Coordinates": "48.2329668,-101.2922906"
       },
       {
         "City": "Palm Springs",
         "Coordinates": "33.8302961,-116.5452921"
       },
       {
         "City": "Pine Bluff",
         "Coordinates": "34.2284312,-92.0031955"
       },
       {
         "City": "Texas City",
         "Coordinates": "29.383845,-94.9027002"
       },
       {
         "City": "Summerville",
         "Coordinates": "33.0185039,-80.1756481"
       },
       {
         "City": "Twin Falls",
         "Coordinates": "42.5629668,-114.4608711"
       },
       {
         "City": "Jeffersonville",
         "Coordinates": "38.2775702,-85.7371847"
       },
       {
         "City": "San Jacinto",
         "Coordinates": "33.7839084,-116.958635"
       },
       {
         "City": "Madison",
         "Coordinates": "34.6992579,-86.7483318"
       },
       {
         "City": "Altoona",
         "Coordinates": "40.5186809,-78.3947359"
       },
       {
         "City": "Columbus",
         "Coordinates": "39.2014404,-85.9213796"
       },
       {
         "City": "Beavercreek",
         "Coordinates": "39.7092262,-84.0632685"
       },
       {
         "City": "Apopka",
         "Coordinates": "28.6934076,-81.5322149"
       },
       {
         "City": "Elmhurst",
         "Coordinates": "41.8994744,-87.9403418"
       },
       {
         "City": "Maricopa",
         "Coordinates": "33.0581063,-112.0476423"
       },
       {
         "City": "Farmington",
         "Coordinates": "36.7280583,-108.2186856"
       },
       {
         "City": "Glenview",
         "Coordinates": "42.0697509,-87.7878408"
       },
       {
         "City": "Cleveland Heights",
         "Coordinates": "41.5200518,-81.556235"
       },
       {
         "City": "Draper",
         "Coordinates": "40.5246711,-111.8638226"
       },
       {
         "City": "Lincoln",
         "Coordinates": "38.891565,-121.2930079"
       },
       {
         "City": "Sierra Vista",
         "Coordinates": "31.5455001,-110.2772856"
       },
       {
         "City": "Lacey",
         "Coordinates": "47.0342629,-122.8231915"
       },
       {
         "City": "Biloxi",
         "Coordinates": "30.3960318,-88.8853078"
       },
       {
         "City": "Strongsville",
         "Coordinates": "41.3144966,-81.83569"
       },
       {
         "City": "Barnstable Town",
         "Coordinates": "41.7003208,-70.3002024"
       },
       {
         "City": "Wylie",
         "Coordinates": "33.0151201,-96.5388789"
       },
       {
         "City": "Sayreville",
         "Coordinates": "40.4594021,-74.360846"
       },
       {
         "City": "Kannapolis",
         "Coordinates": "35.4873613,-80.6217341"
       },
       {
         "City": "Charlottesville",
         "Coordinates": "38.0293059,-78.4766781"
       },
       {
         "City": "Littleton",
         "Coordinates": "39.613321,-105.0166498"
       },
       {
         "City": "Titusville",
         "Coordinates": "28.6122187,-80.8075537"
       },
       {
         "City": "Hackensack",
         "Coordinates": "40.8859325,-74.0434736"
       },
       {
         "City": "Newark",
         "Coordinates": "37.5296593,-122.0402399"
       },
       {
         "City": "Pittsfield",
         "Coordinates": "42.4500845,-73.2453824"
       },
       {
         "City": "York",
         "Coordinates": "39.9625984,-76.727745"
       },
       {
         "City": "Lombard",
         "Coordinates": "41.8800296,-88.0078435"
       },
       {
         "City": "Attleboro",
         "Coordinates": "41.9445441,-71.2856082"
       },
       {
         "City": "DeKalb",
         "Coordinates": "41.9294736,-88.7503647"
       },
       {
         "City": "Blacksburg",
         "Coordinates": "37.2295733,-80.4139393"
       },
       {
         "City": "Dublin",
         "Coordinates": "40.0992294,-83.1140771"
       },
       {
         "City": "Haltom City",
         "Coordinates": "32.7995738,-97.2691817"
       },
       {
         "City": "Lompoc",
         "Coordinates": "34.6391501,-120.4579409"
       },
       {
         "City": "El Centro",
         "Coordinates": "32.792,-115.5630514"
       },
       {
         "City": "Danville",
         "Coordinates": "37.8215929,-121.9999606"
       },
       {
         "City": "Jefferson City",
         "Coordinates": "38.5767017,-92.1735164"
       },
       {
         "City": "Cutler Bay",
         "Coordinates": "25.5808323,-80.3468593"
       },
       {
         "City": "Oakland Park",
         "Coordinates": "26.1723065,-80.1319893"
       },
       {
         "City": "North Miami Beach",
         "Coordinates": "25.9331488,-80.1625463"
       },
       {
         "City": "Freeport",
         "Coordinates": "40.6576022,-73.5831835"
       },
       {
         "City": "Moline",
         "Coordinates": "41.5067003,-90.5151342"
       },
       {
         "City": "Coachella",
         "Coordinates": "33.6803003,-116.173894"
       },
       {
         "City": "Fort Pierce",
         "Coordinates": "27.4467056,-80.3256056"
       },
       {
         "City": "Smyrna",
         "Coordinates": "35.9828412,-86.5186045"
       },
       {
         "City": "Bountiful",
         "Coordinates": "40.8893895,-111.880771"
       },
       {
         "City": "Fond du Lac",
         "Coordinates": "43.7730448,-88.4470508"
       },
       {
         "City": "Everett",
         "Coordinates": "42.40843,-71.0536625"
       },
       {
         "City": "Danville",
         "Coordinates": "36.5859718,-79.3950228"
       },
       {
         "City": "Keller",
         "Coordinates": "32.9341893,-97.229298"
       },
       {
         "City": "Belleville",
         "Coordinates": "38.5200504,-89.9839935"
       },
       {
         "City": "Bell Gardens",
         "Coordinates": "33.9652918,-118.1514588"
       },
       {
         "City": "Cleveland",
         "Coordinates": "35.1595182,-84.8766115"
       },
       {
         "City": "North Lauderdale",
         "Coordinates": "26.217305,-80.2258811"
       },
       {
         "City": "Fairfield",
         "Coordinates": "39.3454673,-84.5603187"
       },
       {
         "City": "Salem",
         "Coordinates": "42.51954,-70.8967155"
       },
       {
         "City": "Rancho Palos Verdes",
         "Coordinates": "33.7444613,-118.3870173"
       },
       {
         "City": "San Bruno",
         "Coordinates": "37.6304904,-122.4110835"
       },
       {
         "City": "Concord",
         "Coordinates": "43.2081366,-71.5375718"
       },
       {
         "City": "Burlington",
         "Coordinates": "44.4758825,-73.212072"
       },
       {
         "City": "Apex",
         "Coordinates": "35.732652,-78.8502856"
       },
       {
         "City": "Midland",
         "Coordinates": "43.6155825,-84.2472116"
       },
       {
         "City": "Altamonte Springs",
         "Coordinates": "28.6611089,-81.3656242"
       },
       {
         "City": "Hutchinson",
         "Coordinates": "38.0608445,-97.9297743"
       },
       {
         "City": "Buffalo Grove",
         "Coordinates": "42.1662831,-87.9631308"
       },
       {
         "City": "Urbandale",
         "Coordinates": "41.6266555,-93.7121656"
       },
       {
         "City": "State College",
         "Coordinates": "40.7933949,-77.8600012"
       },
       {
         "City": "Urbana",
         "Coordinates": "40.1105875,-88.2072697"
       },
       {
         "City": "Plainfield",
         "Coordinates": "41.632223,-88.2120315"
       },
       {
         "City": "Manassas",
         "Coordinates": "38.7509488,-77.4752667"
       },
       {
         "City": "Bartlett",
         "Coordinates": "41.9950276,-88.1856301"
       },
       {
         "City": "Kearny",
         "Coordinates": "40.7684342,-74.1454214"
       },
       {
         "City": "Oro Valley",
         "Coordinates": "32.3909071,-110.966488"
       },
       {
         "City": "Findlay",
         "Coordinates": "41.04422,-83.6499321"
       },
       {
         "City": "Rohnert Park",
         "Coordinates": "38.3396367,-122.7010984"
       },
       {
         "City": "Linden",
         "Coordinates": "40.6220478,-74.2445902"
       },
       {
         "City": "Westfield",
         "Coordinates": "42.1250929,-72.749538"
       },
       {
         "City": "Sumter",
         "Coordinates": "33.9204354,-80.3414693"
       },
       {
         "City": "Wilkes-Barre",
         "Coordinates": "41.2459149,-75.8813075"
       },
       {
         "City": "Woonsocket",
         "Coordinates": "42.0028761,-71.5147839"
       },
       {
         "City": "Leominster",
         "Coordinates": "42.5250906,-71.759794"
       },
       {
         "City": "Shelton",
         "Coordinates": "41.3164856,-73.0931641"
       },
       {
         "City": "Brea",
         "Coordinates": "33.9166805,-117.9000604"
       },
       {
         "City": "Covington",
         "Coordinates": "39.0836712,-84.5085536"
       },
       {
         "City": "Rockwall",
         "Coordinates": "32.9312336,-96.4597089"
       },
       {
         "City": "Meridian",
         "Coordinates": "32.3643098,-88.703656"
       },
       {
         "City": "Riverton",
         "Coordinates": "40.521893,-111.9391023"
       },
       {
         "City": "St. Cloud",
         "Coordinates": "28.2489016,-81.2811801"
       },
       {
         "City": "Quincy",
         "Coordinates": "39.9356016,-91.4098726"
       },
       {
         "City": "Morgan Hill",
         "Coordinates": "37.1305012,-121.6543901"
       },
       {
         "City": "Warren",
         "Coordinates": "41.2375569,-80.8184166"
       },
       {
         "City": "Edmonds",
         "Coordinates": "47.8106521,-122.3773552"
       },
       {
         "City": "Burleson",
         "Coordinates": "32.5420821,-97.3208492"
       },
       {
         "City": "Beverly",
         "Coordinates": "42.5584283,-70.880049"
       },
       {
         "City": "Mankato",
         "Coordinates": "44.1635775,-93.9993996"
       },
       {
         "City": "Hagerstown",
         "Coordinates": "39.6417629,-77.7199932"
       },
       {
         "City": "Prescott",
         "Coordinates": "34.5400242,-112.4685025"
       },
       {
         "City": "Campbell",
         "Coordinates": "37.2871651,-121.9499568"
       },
       {
         "City": "Cedar Falls",
         "Coordinates": "42.5348993,-92.4453161"
       },
       {
         "City": "Beaumont",
         "Coordinates": "33.9294606,-116.977248"
       },
       {
         "City": "La Puente",
         "Coordinates": "34.0200114,-117.9495083"
       },
       {
         "City": "Crystal Lake",
         "Coordinates": "42.2411344,-88.3161965"
       },
       {
         "City": "Fitchburg",
         "Coordinates": "42.5834228,-71.8022955"
       },
       {
         "City": "Carol Stream",
         "Coordinates": "41.9125286,-88.1347927"
       },
       {
         "City": "Hickory",
         "Coordinates": "35.7344538,-81.3444573"
       },
       {
         "City": "Streamwood",
         "Coordinates": "42.0255827,-88.1784085"
       },
       {
         "City": "Norwich",
         "Coordinates": "41.5242649,-72.0759105"
       },
       {
         "City": "Coppell",
         "Coordinates": "32.9545687,-97.0150078"
       },
       {
         "City": "San Gabriel",
         "Coordinates": "34.0961111,-118.1058333"
       },
       {
         "City": "Holyoke",
         "Coordinates": "42.2042586,-72.6162009"
       },
       {
         "City": "Bentonville",
         "Coordinates": "36.3728538,-94.2088172"
       },
       {
         "City": "Florence",
         "Coordinates": "34.79981,-87.677251"
       },
       {
         "City": "Peachtree Corners",
         "Coordinates": "33.9698929,-84.2214551"
       },
       {
         "City": "Brentwood",
         "Coordinates": "36.0331164,-86.7827772"
       },
       {
         "City": "Bozeman",
         "Coordinates": "45.6769979,-111.0429339"
       },
       {
         "City": "New Berlin",
         "Coordinates": "42.9764027,-88.1084224"
       },
       {
         "City": "Goose Creek",
         "Coordinates": "32.9810059,-80.0325867"
       },
       {
         "City": "Huntsville",
         "Coordinates": "30.7235263,-95.5507771"
       },
       {
         "City": "Prescott Valley",
         "Coordinates": "34.6100243,-112.315721"
       },
       {
         "City": "Maplewood",
         "Coordinates": "44.9530215,-92.9952153"
       },
       {
         "City": "Romeoville",
         "Coordinates": "41.6475306,-88.0895061"
       },
       {
         "City": "Duncanville",
         "Coordinates": "32.6518004,-96.9083366"
       },
       {
         "City": "Atlantic City",
         "Coordinates": "39.3642834,-74.4229266"
       },
       {
         "City": "Clovis",
         "Coordinates": "34.4047987,-103.2052272"
       },
       {
         "City": "The Colony",
         "Coordinates": "33.0806083,-96.8928309"
       },
       {
         "City": "Culver City",
         "Coordinates": "34.0211224,-118.3964665"
       },
       {
         "City": "Marlborough",
         "Coordinates": "42.3459271,-71.5522874"
       },
       {
         "City": "Hilton Head Island",
         "Coordinates": "32.216316,-80.752608"
       },
       {
         "City": "Moorhead",
         "Coordinates": "46.8737648,-96.7678039"
       },
       {
         "City": "Calexico",
         "Coordinates": "32.6789476,-115.4988834"
       },
       {
         "City": "Bullhead City",
         "Coordinates": "35.1359386,-114.5285981"
       },
       {
         "City": "Germantown",
         "Coordinates": "35.0867577,-89.8100858"
       },
       {
         "City": "La Quinta",
         "Coordinates": "33.6633573,-116.3100095"
       },
       {
         "City": "Lancaster",
         "Coordinates": "39.7136754,-82.5993294"
       },
       {
         "City": "Wausau",
         "Coordinates": "44.9591352,-89.6301221"
       },
       {
         "City": "Sherman",
         "Coordinates": "33.6356618,-96.6088805"
       },
       {
         "City": "Ocoee",
         "Coordinates": "28.5691677,-81.5439619"
       },
       {
         "City": "Shakopee",
         "Coordinates": "44.7973962,-93.5272861"
       },
       {
         "City": "Woburn",
         "Coordinates": "42.4792618,-71.1522765"
       },
       {
         "City": "Bremerton",
         "Coordinates": "47.5673202,-122.6329356"
       },
       {
         "City": "Rock Island",
         "Coordinates": "41.5094771,-90.5787476"
       },
       {
         "City": "Muskogee",
         "Coordinates": "35.7478769,-95.3696909"
       },
       {
         "City": "Cape Girardeau",
         "Coordinates": "37.3058839,-89.5181476"
       },
       {
         "City": "Annapolis",
         "Coordinates": "38.9784453,-76.4921829"
       },
       {
         "City": "Greenacres",
         "Coordinates": "26.6276276,-80.1353896"
       },
       {
         "City": "Ormond Beach",
         "Coordinates": "29.2858129,-81.0558894"
       },
       {
         "City": "Hallandale Beach",
         "Coordinates": "25.9812024,-80.148379"
       },
       {
         "City": "Stanton",
         "Coordinates": "33.8025155,-117.9931165"
       },
       {
         "City": "Puyallup",
         "Coordinates": "47.1853785,-122.2928974"
       },
       {
         "City": "Pacifica",
         "Coordinates": "37.6138253,-122.4869194"
       },
       {
         "City": "Hanover Park",
         "Coordinates": "41.9994722,-88.1450735"
       },
       {
         "City": "Hurst",
         "Coordinates": "32.8234621,-97.1705678"
       },
       {
         "City": "Lima",
         "Coordinates": "40.742551,-84.1052256"
       },
       {
         "City": "Marana",
         "Coordinates": "32.436381,-111.2224422"
       },
       {
         "City": "Carpentersville",
         "Coordinates": "42.1211364,-88.2578582"
       },
       {
         "City": "Oakley",
         "Coordinates": "37.9974219,-121.7124536"
       },
       {
         "City": "Huber Heights",
         "Coordinates": "39.843947,-84.1246608"
       },
       {
         "City": "Lancaster",
         "Coordinates": "32.5920798,-96.7561082"
       },
       {
         "City": "Montclair",
         "Coordinates": "34.0775104,-117.6897776"
       },
       {
         "City": "Wheeling",
         "Coordinates": "42.1391927,-87.9289591"
       },
       {
         "City": "Brookfield",
         "Coordinates": "43.0605671,-88.1064787"
       },
       {
         "City": "Park Ridge",
         "Coordinates": "42.0111412,-87.8406192"
       },
       {
         "City": "Florence",
         "Coordinates": "34.1954331,-79.7625625"
       },
       {
         "City": "Roy",
         "Coordinates": "41.1616108,-112.0263313"
       },
       {
         "City": "Winter Garden",
         "Coordinates": "28.5652787,-81.5861847"
       },
       {
         "City": "Chelsea",
         "Coordinates": "42.3917638,-71.0328284"
       },
       {
         "City": "Valley Stream",
         "Coordinates": "40.6642699,-73.7084645"
       },
       {
         "City": "Spartanburg",
         "Coordinates": "34.9495672,-81.9320482"
       },
       {
         "City": "Lake Oswego",
         "Coordinates": "45.4206749,-122.6706498"
       },
       {
         "City": "Friendswood",
         "Coordinates": "29.5293998,-95.2010447"
       },
       {
         "City": "Westerville",
         "Coordinates": "40.1261743,-82.9290696"
       },
       {
         "City": "Northglenn",
         "Coordinates": "39.8961821,-104.9811468"
       },
       {
         "City": "Phenix City",
         "Coordinates": "32.4709761,-85.0007653"
       },
       {
         "City": "Grove City",
         "Coordinates": "39.8814519,-83.0929644"
       },
       {
         "City": "Texarkana",
         "Coordinates": "33.425125,-94.0476882"
       },
       {
         "City": "Addison",
         "Coordinates": "41.931696,-87.9889556"
       },
       {
         "City": "Dover",
         "Coordinates": "39.158168,-75.5243682"
       },
       {
         "City": "Lincoln Park",
         "Coordinates": "42.2505943,-83.1785361"
       },
       {
         "City": "Calumet City",
         "Coordinates": "41.6155909,-87.5294871"
       },
       {
         "City": "Muskegon",
         "Coordinates": "43.2341813,-86.2483921"
       },
       {
         "City": "Aventura",
         "Coordinates": "25.9564812,-80.1392121"
       },
       {
         "City": "Martinez",
         "Coordinates": "38.0193657,-122.1341321"
       },
       {
         "City": "Greenfield",
         "Coordinates": "42.9614039,-88.0125865"
       },
       {
         "City": "Apache Junction",
         "Coordinates": "33.4150485,-111.5495777"
       },
       {
         "City": "Monrovia",
         "Coordinates": "34.1442616,-118.0019482"
       },
       {
         "City": "Weslaco",
         "Coordinates": "26.1595194,-97.9908366"
       },
       {
         "City": "Keizer",
         "Coordinates": "44.9901194,-123.0262077"
       },
       {
         "City": "Spanish Fork",
         "Coordinates": "40.114955,-111.654923"
       },
       {
         "City": "Beloit",
         "Coordinates": "42.5083482,-89.0317765"
       },
       {
         "City": "Panama City",
         "Coordinates": "30.1588129,-85.6602058"
       }
      ]
   }
}

export default UsCities;



// WEBPACK FOOTER //
// app/client/bundles/EmailCampaign/UsCities.js